import { CopyToUser } from './copy-to-users.interface';
import { DisputeOrderInfo } from './dispute-order-info';

export class TicketResponseModel {
    operatingCountryId: number;
    source: string;
    callerName: string;
    callerPhoneNumber: number;
    ticketType: string;
    subType: string;
    disputeTypeId?: number;
    orderId: string;
    reason: string;
    departmentName: string;
    assignedToId: number;
    assignedToValue: string;
    isAssignedToMe: boolean;
    priorityId: number;
    dueDate: Date;
    subject: string;
    description: string;
    status: string;
    statusId: number;
    priority: string;
    typeId: number;
    subTypeId: number;
    departmentId: number;
    memberId: string;
    memberType: any;
    sourceId: number;
    sourceIdentifierValue: string;
    note: string;
    // notes: string;
    filePath: Array<string>;
    sourceValue: string;
    typeValue: string;
    subTypeValue: string;
    priorityValue: string;
    statusValue: string;
    createdByValue: string;
    updatedByValue: string;
    attachments: any[];
    notes: any[];
    id: number;
    closedReason: string;
    createdDate: Date;
    ticketNumber: string;
    updatedDate: Date;
    disputes?: DisputeOrderInfo[];
    copyToUsers?: CopyToUser[];
    createdBy?: number;
    updatedBy?: number;
    sendMailNotification?: boolean;
    orderReasonNotes?: string;
    assignedToEmail?: string;
    countryId?: number;
    locationTypeId?: number;
    operatingCountryCode?: string;
    departmentEmail?: string;
    
}





// WEBPACK FOOTER //
// ./src/app/customerservice/interface/ticketingsystem/ticket-response.model.ts